/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './equipment-ip-charges.reducer';

export const EquipmentIPCharges = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const equipmentIPChargesList = useAppSelector(state => state.equipmentIPCharges.entities);
  const loading = useAppSelector(state => state.equipmentIPCharges.loading);
  const totalItems = useAppSelector(state => state.equipmentIPCharges.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="equipment-ip-charges-heading" data-cy="EquipmentIPChargesHeading">
        <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.home.title">Equipment IP Charges</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/equipment-ip-charges/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.home.createLabel">Create new Equipment IP Charges</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.equipmentIPCharges.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {equipmentIPChargesList && equipmentIPChargesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('maxDiscount')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.maxDiscount">Max Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxDiscount')} />
                </th>
                <th className="hand" onClick={sort('chargeType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.chargeType">Charge Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargeType')} />
                </th>
                <th className="hand" onClick={sort('multiplierApplied')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.multiplierApplied">Multiplier Applied</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplierApplied')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.equipment">Equipment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {equipmentIPChargesList.map((equipmentIPCharges, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/equipment-ip-charges/${equipmentIPCharges.id}`} color="link" size="sm">
                      {equipmentIPCharges.id}
                    </Button>
                  </td>
                  <td>{equipmentIPCharges.active ? 'true' : 'false'}</td>
                  <td>{equipmentIPCharges.cursor}</td>
                  <td>{equipmentIPCharges.lastUpdated}</td>
                  <td>{equipmentIPCharges.microSec}</td>
                  <td>{equipmentIPCharges.timestampEntry}</td>
                  <td>{equipmentIPCharges.price}</td>
                  <td>{equipmentIPCharges.maxDiscount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ChargeType.${equipmentIPCharges.chargeType}`} />
                  </td>
                  <td>{equipmentIPCharges.multiplierApplied ? 'true' : 'false'}</td>
                  <td>{equipmentIPCharges.startDate}</td>
                  <td>{equipmentIPCharges.endDate}</td>
                  <td>{equipmentIPCharges.suspended ? 'true' : 'false'}</td>
                  <td>{equipmentIPCharges.draft ? 'true' : 'false'}</td>
                  <td>
                    {equipmentIPCharges.equipment ? (
                      <Link to={`/equipment-ip/${equipmentIPCharges.equipment.id}`}>{equipmentIPCharges.equipment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {equipmentIPCharges.scheme ? (
                      <Link to={`/payment-scheme/${equipmentIPCharges.scheme.id}`}>{equipmentIPCharges.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/equipment-ip-charges/${equipmentIPCharges.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/equipment-ip-charges/${equipmentIPCharges.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/equipment-ip-charges/${equipmentIPCharges.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.home.notFound">No Equipment IP Charges found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={equipmentIPChargesList && equipmentIPChargesList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default EquipmentIPCharges;
